import { fmtDayIso } from "./anacStatus";

// Panorama ANAC da turma (ou de todas): contagens para ver de relance o estado dos alunos
// e quem tem exame ANAC marcado neste mês. Usa o resumo ANAC que já vem na lista de alunos.
export default function AnacPanorama({ students }) {
  const rows = (students || []).filter((s) => s.anac);
  if (rows.length === 0) return null;

  const now = new Date();
  const thisMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;

  const monthExams = rows
    .filter((s) => s.anac.next_exam && s.anac.next_exam.source === "anac" && s.anac.next_exam.date.startsWith(thisMonth))
    .sort((a, b) => a.anac.next_exam.date.localeCompare(b.anac.next_exam.date));

  const count = (fn) => rows.filter(fn).length;
  const chips = [
    { label: "Concluíram as teóricas", value: count((s) => s.anac.all_approved), cls: "border-emerald-500/40 text-emerald-300" },
    { label: "Exame nos próximos 30 dias", value: count((s) => s.anac.next_exam && s.anac.next_exam.days_left <= 30), cls: "border-sky-500/40 text-sky-300" },
    { label: "Sem exame marcado", value: count((s) => !s.anac.next_exam && !s.anac.all_approved), cls: "border-slate-600 text-slate-300" },
    { label: "Sem início do curso", value: count((s) => !s.anac.course_start), cls: "border-amber-500/50 text-amber-300" },
    { label: "Precisam de atenção", value: count((s) => s.anac.needs_new_course || s.anac.expired), cls: "border-red-500/50 text-red-300" },
  ];

  return (
    <div className="mb-4 rounded-lg border border-sky-500/30 bg-sky-500/5 p-3" data-testid="anac-panorama">
      <div className="text-xs uppercase tracking-wider text-sky-300 mb-2">Panorama ANAC · {rows.length} alunos</div>
      <div className="flex flex-wrap gap-2 mb-3">
        {chips.map((c) => (
          <span key={c.label} className={`px-2 py-1 rounded border text-xs ${c.cls}`}>
            <b className="font-mono">{c.value}</b> {c.label}
          </span>
        ))}
      </div>
      <div className="text-xs text-slate-300">
        <span className="text-slate-500">Exames ANAC marcados para este mês:</span>{" "}
        {monthExams.length === 0 ? (
          <span className="text-slate-500 italic">nenhum</span>
        ) : (
          monthExams.map((s) => (
            <span key={s.user_id} className="inline-block mr-2 mt-1 px-1.5 py-0.5 rounded border border-sky-500/40">
              {fmtDayIso(s.anac.next_exam.date)} · {s.name} · {s.anac.next_exam.label}
            </span>
          ))
        )}
      </div>
    </div>
  );
}
